module.exports = __webpack_public_path__ + "8d60e222edf2c44618f3f116950d9857.pdf";